export default store => {
	store.watch(
		() => ({
			validSession: store.getters["session/validSession"]
		}),
		({ validSession }) => {
			window.location.reload();
		}
	);
};